import React from "react";
import { useClasses } from "../../";
import classnames from "classnames";
import Col from "./Col";
function isStringOrNumber(value) {
    return typeof value === "string" || typeof value === "number";
}
function isObject(value) {
    return typeof value === "object" && !Array.isArray(value) && value !== null;
}
function getColProps(rowProps, childProps) {
    const setProps = isObject(childProps)
        ? childProps
        : {};
    const props = {
        spacing: typeof setProps.spacing === "number"
            ? setProps.spacing
            : rowProps.spacing,
        vertical: rowProps.vertical,
        parts: rowProps.parts,
    };
    if (isStringOrNumber(setProps.xs))
        props.xs = setProps.xs;
    if (isStringOrNumber(setProps.sm))
        props.sm = setProps.sm;
    if (isStringOrNumber(setProps.md))
        props.md = setProps.md;
    if (isStringOrNumber(setProps.lg))
        props.lg = setProps.lg;
    if (isStringOrNumber(setProps.xl))
        props.xl = setProps.xl;
    if (isStringOrNumber(setProps.print))
        props.print = setProps.print;
    if (setProps.stretch)
        props.stretch = true;
    if (isObject(setProps.override) && typeof setProps.override.col === "string")
        props.override = setProps.override;
    return props;
}
function getHorizontalAlign(value) {
    if (value === "right")
        return "flex-end";
    if (value === "center")
        return "center";
    if (value === "space-between")
        return "space-between";
    if (value === "space-around")
        return "space-around";
    return "flex-start";
}
function getVerticalAlign(value) {
    if (value === "bottom")
        return "flex-end";
    if (value === "center")
        return "center";
    if (value === "baseline")
        return "space-between";
    if (value === "stretch")
        return "stretch";
    return "flex-start";
}
function getRoot(value) {
    if (typeof value === "undefined")
        return {};
    if (typeof value === "number")
        return { top: value, left: value, right: value, bottom: value };
    return value;
}
const styles = (theme) => ({
    root: {
        height: (props) => (props.stretch ? "100%" : "auto"),
        padding: (props) => {
            const defaultHSize = props.spacing || 0;
            const defaultVSize = props.vertical ? props.spacing || 0 : 0;
            const root = getRoot(props.root);
            return `${typeof root.top !== "undefined" ? root.top : defaultVSize}px ${typeof root.right !== "undefined" ? root.right : defaultHSize}px ${typeof root.bottom !== "undefined" ? root.bottom : defaultVSize}px ${typeof root.left !== "undefined" ? root.left : defaultHSize}px`;
        },
    },
    row: {
        height: (props) => (props.stretch ? "100%" : "auto"),
        margin: (props) => `${props.vertical ? (props.spacing || 0) / -2 : 0}px -${(props.spacing || 0) / 2}px`,
        display: "flex",
        justifyContent: (props) => getHorizontalAlign(props.horizontalAlign),
        alignItems: (props) => getVerticalAlign(props.verticalAlign),
        flexFlow: (props) => props.flow || "row wrap",
    },
});
function isCol(element) {
    if (React.isValidElement(element)) {
        const toTest = element.type;
        return (typeof toTest === "object" && toTest !== null && toTest.type === Col.type);
    }
    return false;
}
let index = 0;
export default function Row(props) {
    const { children, override = {} } = props;
    const classes = useClasses(styles, props);
    return (React.createElement("div", { className: classnames([classes.root, override.root]) },
        React.createElement("div", { className: classnames([classes.row, override.row]) }, React.Children.map(children, (child) => {
            const childProps = React.isValidElement(child)
                ? { ...child.props, key: "col-row-" + index }
                : {};
            //child is wrapped in col
            if (isCol(child))
                return React.cloneElement(child, getColProps(props, childProps));
            //child is not wrapped in a col
            if (child !== null && child !== false && child !== undefined)
                return React.createElement(Col, { ...getColProps(props, childProps) }, child);
            //child won't be visible
            return child;
        }))));
}
